import { convertToHourlyUTC } from '@components/sources/visualizer/mappingScreens/sourceUtil';
import { apiAuthCaller } from '@services/apiCaller';
import { ISource } from '@stores/source';
import { FixMe } from '@utils/types';
import moment from 'moment';

export interface ICustomResources {
  id: string;
  role: string;
  name: string;
  config: FixMe;
}

const syncingDelayMins = 0;

// rETL
const getModeQueryString = (syncBehaviourMode?: string) =>
  syncBehaviourMode ? `&mode=${syncBehaviourMode}` : '';

// rETL
const fetchPendingJobsReports = async (
  {
    from,
    to,
    destinationId,
    pending,
  }: {
    from: string;
    to: string;
    destinationId?: string;
    pending?: string[];
  },
  source: ISource,
  token: string,
  workspaceId: string,
) => {
  const modeQueryString = getModeQueryString(source.config.syncBehaviour?.mode);
  const url = `/reports/report?sourceId=${
    source.id
  }&destinationId=${destinationId}&from=${convertToHourlyUTC(
    from,
    'floor',
  )}&to=${convertToHourlyUTC(to, 'ceil')}&workspaceId=${workspaceId}${modeQueryString}`;

  const response = await apiAuthCaller(token).post(url, { pending });
  return response.data.data;
};

// rETL
const getReports = async (
  {
    from,
    to,
    destinationId,
  }: {
    from: string;
    to: string;
    destinationId?: string;
  },
  source: ISource,
  token: string,
  workspaceId: string,
) => {
  const url = '/reports/report';
  const params = {
    sourceId: source.id,
    destinationId,
    from: convertToHourlyUTC(from, 'floor'),
    to: convertToHourlyUTC(to, 'ceil'),
    mode: source?.config?.syncBehaviour?.mode,
    workspaceId,
  };
  const response = await apiAuthCaller(token).get(url, { params });

  return response.data.data;
};

// cloud
const mapSourceHistoryWithCustomResource = (history: FixMe[], customResources: FixMe[]) =>
  customResources && customResources.length > 0
    ? history.map((run: FixMe) => {
        const customResource = customResources.find((cr: FixMe) => cr.id === run.taskId);
        if (customResource) {
          return {
            ...run,
            taskId: `${customResource.name} - ${run.taskId}`,
          };
        }
        return run;
      })
    : history;

// cloud
const getCustomResources = async (sourceId: string, token: string) => {
  const customResourcesResponse = await apiAuthCaller(token).get(
    `/cloudSources/source/${sourceId}/resources`,
  );
  return customResourcesResponse.data;
};

// cloud
const getLastRunAndCustomResources = async (
  source: ISource,
  token: string,
  customResources: ICustomResources | null,
  workspaceId: string,
) => {
  const url = `reports/workspaces/${workspaceId}/cloudSources/lastStatus/${source?.id}`;

  const response = await apiAuthCaller(token).get(url, { params: { workspaceId } });
  const updatedCustomResources = customResources || (await getCustomResources(source.id, token));
  // replace id of custom resources if exists with the resource name
  const lastRunData = mapSourceHistoryWithCustomResource(response.data, updatedCustomResources);

  return { updatedCustomResources, lastRunData };
};

// cloud and rETL
const startSync = (source: ISource, token: string, syncType?: string) => {
  window.rudderanalytics.track('Sync now triggered', {
    sourceID: source?.id,
    destinationIds: source?.destinations?.map((d) => d.id),
  });
  const syncTypeBody = syncType ? { sync_type: syncType } : undefined;
  return apiAuthCaller(token).post(`/cloudSources/run/${source.id}/start`, syncTypeBody);
};

// cloud
const stopSync = (sourceId: string, token: string) =>
  apiAuthCaller(token).post(`/cloudSources/run/${sourceId}/stop`);
const isSyncing = (startedAt: string, finishedAt?: string, addDelay = true) =>
  !finishedAt ||
  moment(startedAt).isAfter(moment(finishedAt)) ||
  (addDelay && moment().diff(moment(finishedAt), 'minutes') < syncingDelayMins);
export {
  fetchPendingJobsReports,
  getReports,
  startSync,
  stopSync,
  isSyncing,
  getLastRunAndCustomResources,
};
